<template>
  <div class="row">
    <div class="contents_area">
      <div class="header_container">
        <h4 class="mb60">
          Questions & Answers
        </h4>
      </div>
      <div
          v-for="item in accordionInfo"
          :key="item.id"
          class="accordion_container"
      >
        <div
            @click="toggleAccordion(item)"
            class="accordion_header"
        >
          <h6>{{ item.title }}</h6>
          <div
              :class="item.expanded? 'opened' : 'closed'"
              class="accordion_arrow"
          >
            <img src="/images/ic/comm/ic-arrow-down.svg" alt="">
          </div>
        </div>
        <div :class="item.expanded? 'accordion_desc show' : 'accordion_desc'">
          <p class="txt_body_1 --grey80">
            {{ item.desc }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {
  },
  data() {
    return {
      accordionInfo: [
        {
          id: 'test1',
          title: 'Do my clients have to pay to use rebless.Clinic?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: true
        },
        {
          id: 'test2',
          title: 'Can I change my plan later?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: false
        },
        {
          id: 'test3',
          title: 'What is an active client?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: false
        },
        {
          id: 'test4',
          title: 'How does the 30-day free trial work?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: false
        },
        {
          id: 'test5',
          title: 'Do you have a Business Associate Agreement?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: false
        },
        {
          id: 'test6',
          title: 'Is rebless.Clinic compliant with HIPAA’s security and privacy policies?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: false
        },
        {
          id: 'test7',
          title: 'How do I cancel my subscription?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: false
        },
        {
          id: 'test8',
          title: 'Can I export data from rebless.Clinic?',
          desc: 'After your free 30-day trial, there are no contracts, and your subscription is paid on a month-to-month basis.\n' +
              '            You can cancel at any time, but you are responsible for any charges already incurred.\n' +
              '            We do not provide refunds.',
          expanded: false
        }
      ]
    }
  },
  methods: {
    toggleAccordion(item) {
      this.accordionInfo.forEach((_item) => {
        if (_item.id === item.id) {
          _item.expanded = !item.expanded;
        } else {
          _item.expanded = false;
        }
      });
    }
  }
}
</script>
<style lang="scss">
.accordion_container {
  .accordion_header {
    border-top: 1px solid var(--grey20);
    display: flex;
    justify-content: space-between;
    padding: 22px 16px 22px 16px;
    cursor: pointer;
    align-items: center;

    .accordion_arrow {
      &.opened {
        transform: rotate(180deg);
        transition-duration: 250ms;

      }

      &.closed {
        transition-duration: 250ms;
      }
    }
  }

  .accordion_desc {
    height: 0;
    overflow: hidden;
    padding: 0 10px;
    transition-duration: 250ms;

    &.show {
      padding: 4px 16px 32px;
      height: auto;
      overflow: visible;
      transition-duration: 250ms;
    }
  }

  &:last-child {
    border-bottom: 1px solid var(--grey20);
  }
}
</style>